import React, { useRef, useState } from 'react'
import './DataSet.css'
import DataSetBox from './DataSetBox'

export default function DataSet() {

    const [isMouseDown, setIsMouseDown] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const containerRef = useRef(null);

    const onMouseDown = (e) => {
        setIsMouseDown(true);
        setStartX(e.clientX - containerRef.current.offsetLeft);
        setScrollLeft(containerRef.current.scrollLeft);
    };

    const onMouseLeave = () => {
        setIsMouseDown(false);
    };

    const onMouseUp = () => {
        setIsMouseDown(false);
    };

    const onMouseMove = (e) => {
        if (!isMouseDown) return;
        const x = e.clientX - containerRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed multiplier
        containerRef.current.scrollLeft = scrollLeft - walk;
    };

    const datasets = [
        {
            datasetName: "Events_Data_fct.csv",
            datasetDesc: "Contains detailed records of events, including dates, locations, organizers, pricing, registrations, attendance, and profitability metrics.",
            image: "/datasetImage1.png"
        },
        {
            datasetName: "Category_dim.csv",
            datasetDesc: "Classifies events into thematic domains such as Technology, Sports, Business, etc.",
            image: "/datasetImage2.png"
        },
        {
            datasetName: "City_dim.csv",
            datasetDesc: "Lists cities where events were held, used for geographic analysis.",
            image: "/datasetImage3.png"
        },
        {
            datasetName: "State_dim.csv",
            datasetDesc: "Provides state-level categorization to support regional insights.",
            image: "/datasetImage4.png"
        },
        {
            datasetName: "Organizer_dim.csv",
            datasetDesc: "Captures details about the event organizers.",
            image: "/datasetImage5.png"
        },
        {
            datasetName: "Venue_dim.csv",
            datasetDesc: " Includes information on event venues for location-level analysis.",
            image: "/datasetImage6.png"
        }

    ]
    return (
        <div>
            <p className='DatasetHeading'>DATA SET</p>
            <p className='DatasetIntro'>Participants will be provided with a comprehensive collection of datasets covering various aspects of event
                management. These datasets capture key details on event organization, participation, location-based insights,
                category performance, and attendee engagement. The datasets include
                :</p>

            <div className='allDatasets' ref={containerRef}
                onMouseDown={onMouseDown}
                onMouseLeave={onMouseLeave}
                onMouseUp={onMouseUp}
                onMouseMove={onMouseMove}>
                {
                    datasets?.map((e, id) => {
                        return (
                            <DataSetBox key={id} datasetName={e?.datasetName} datasetDesc={e?.datasetDesc} image={e?.image} />
                        )
                    })
                }
            </div>

            <div className='additionalInfoSection'>
                <p className='additionalText'>To ensure participants can effectively work with the data, the following resources
                    will also be provided:</p>
                <ul>
                    <li className='additionalText'><span style={{ color: "black" }}>Data Dictionary : </span> Contains the structure, definitions, and
                        relationships within the datasets.</li>
                    <li className='additionalText'><span style={{ color: "black" }}>Insight Requirements : </span> A step-by-step document detailing the procedural
                        guidelines for the submission of entries, ensuring a seamless and efficient submission process.</li>
                </ul>
            </div>

        </div>
    )
}
